import { Component, AfterViewInit, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild, SimpleChanges } from '@angular/core';

import { BaseFilterCollapse, BaseFilterCollapseService } from '../../../core';
import { FormaPagamentoFilter } from './forma-pagamento-filter';
import { formaPagamentoSituacoes, formaPagamentoSituacaoAtiva } from '../forma-pagamento-situacao';

@Component({
    selector: 'sgt-forma-pagamento-filter',
    templateUrl: './forma-pagamento-filter-collapse.component.html',
    styleUrls: ['./forma-pagamento-filter-collapse.component.less']
})
export class FormaPagamentoFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = true;


    @Input() filter: FormaPagamentoFilter;
    @Output() filterInitialized = new EventEmitter<any>();
    situacoes = formaPagamentoSituacoes;

    constructor(private baseFilterCollapseService: BaseFilterCollapseService) { }

    ngOnInit() {
        this.initFilter();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    ngAfterViewInit() {
      if (!this.isCollapsedInDefault) {
        jQuery(this.filterCollapse.nativeElement).css('display', 'none');
      }
    }

    /** Seta os filtros padrões */
    private setDefaultFilters() {
        this.filter.situacao = formaPagamentoSituacaoAtiva.id;
        this.isFilterDirty = true;
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.setDefaultFilters();
        this.filterInitialized.emit(); // Emitindo o evento de que o filtro foi inicializado
    }


    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);

        this.setDefaultFilters();
    }
}
